/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pl_Pnk_Item_Err_Pick_LotInputs */

const vi_pl_pnk_item_err_pick_lot = /** @type {(inputs: Pl_Pnk_Item_Err_Pick_LotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn lô chè mua`)
};

/**

* @param {Pl_Pnk_Item_Err_Pick_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pl_pnk_item_err_pick_lot = /** @type {((inputs?: Pl_Pnk_Item_Err_Pick_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pl_Pnk_Item_Err_Pick_LotInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pl_pnk_item_err_pick_lot(inputs)
});